<template>
	<input
		class="slider-box"
		type="text"
		ref="input"
		:step="step"
		:value="focused ? value : `${value} ${units}`"
		:disabled="disabled"
		:class="custom_class"
		:style="custom_style"
		@input="oninput($event)"
		@mousedown.stop="mousedown($event)"
		@touchstart.stop="mousedown($event)"
	/>
</template>

<script>
export default {
	data() {
		return {
			dragging: false,
			focused: false,
			mouse_start_x: {},
			total_drag_movement: 0,
			value_internal: null
		};
	},
	props: {
		value: {
			type: Number,
			required: true
		},
		units: {
			type: String,
			required: false,
			default: ""
		},
		step: {
			type: Number,
			required: false,
			default: 1
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		min: {
			type: Number,
			required: false
		},
		max: {
			type: Number,
			required: false
		},
		custom_style: {
			type: Object,
			required: false
		},
		custom_class: {
			type: String,
			required: false
		}
	},
	watch: {
		value(val) {
			this.value_internal = val;
		},
		value_internal(val) {
			if (val !== "" && val !== this.value) this.$emit("input", val);
		}
	},
	methods: {
		mousedown(event) {
			let el = this.$refs.input;

			if (el !== document.activeElement) {
				event.preventDefault();

				this.total_drag_movement = 0;

				this.mouse_start_x = event.clientX || event.touches[0].clientX;

				this.addMouseListeners();

				this.dragging = true;
			}
		},
		mousemove(event) {
			if (this.dragging) {
				const mouseX = event.clientX || event.touches[0].clientX;
				const movementX = mouseX - this.mouse_start_x;

				this.value_internal += Math.floor(movementX);
				if (this.min)
					this.value_internal = Math.max(
						this.value_internal,
						this.min
					);
				if (this.max)
					this.value_internal = Math.min(
						this.value_internal,
						this.max
					);

				this.total_drag_movement += Math.abs(movementX);
				this.mouse_start_x = mouseX;
			}
		},
		mouseup() {
			this.removeMouseListeners();

			this.dragging = false;

			if (this.total_drag_movement === 0) this.focusInput();
			else this.$emit("inputend");
		},
		oninput(event) {
			let val = event.target.value.replace(/(?!-)[^0-9.]/g, "");

			event.target.value = val;

			this.value_internal = isNaN(parseInt(val)) ? val : parseInt(val);
		},
		focusInput() {
			this.$refs.input.focus();
			this.focused = true;

			this.$refs.input.onblur = event => {
				if (event.target.value === "") this.value_internal = 0;

				if (this.min)
					this.value_internal = Math.max(
						this.value_internal,
						this.min
					);
				if (this.max)
					this.value_internal = Math.min(
						this.value_internal,
						this.max
					);

				this.focused = false;

				this.$emit("inputend");
			};

			document.addEventListener("keyup", this.keyup, true);
		},
		keyup(event) {
			if (event.key === "Enter" || event.key === "Escape") {
				this.$refs.input.blur();

				document.removeEventListener("keyup", this.keyup, true);
			}
		},
		addMouseListeners() {
			document.addEventListener("mousemove", this.mousemove, true);
			document.addEventListener("touchmove", this.mousemove, true);
			document.addEventListener("mouseup", this.mouseup, true);
			document.addEventListener("touchend", this.mouseup, true);
		},
		removeMouseListeners() {
			document.removeEventListener("mousemove", this.mousemove, true);
			document.removeEventListener("touchmove", this.mousemove, true);
			document.removeEventListener("mouseup", this.mouseup, true);
			document.removeEventListener("touchend", this.mouseup, true);
		}
	},
	created() {
		this.value_internal = this.value;
	}
};
</script>

<style scoped>
.slider-box {
	width: 100%;
}
.slider-box:hover {
	cursor: col-resize;
}
.slider-box:focus {
	cursor: text;
}
</style>
